import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { alert } from 'devextreme/ui/dialog';
import { environment } from '../../../../environments/environment';
import { NicaFormComponent } from '../../nica-form/nica-form.component';
import { IChartContent } from '../nica-chart-maker/IChartContent';
import { getGraficoJSON, Statistiche } from './graficiJsonGenerator';

@Component({
  selector: 'app-nica-chart-maker-form',
  templateUrl: './nica-chart-maker-form.component.html',
  styleUrls: ['./nica-chart-maker-form.component.css','../../../components/shared/anteprima-pdf/anteprima-pdf.component.css']
})
export class NicaChartMakerFormComponent implements OnInit {

  formDataJSON:any;
  pulsantiToolbarGrafici:any[];
  emettiJsonGrafico:EventEmitter<IChartContent> = new EventEmitter<IChartContent>();
  @ViewChild("statisticheRifiutiGrafiche",{static:false}) statisticheRifiutiGrafiche : NicaFormComponent;
  valori : string[]= ['Peso[Kg]','Volume[Mc]','Nr. Movim.'];
  valore = this.valori[0];
  /*
  buttonCustom = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Genera Grafico',
      icon: "glyphicon mdi mdi-content-save-outline",
      event: 'generaGrafico',
      
    }
  ];*/


  constructor(private http:HttpClient,private router:Router) { }

  async ngOnInit() {

    this.pulsantiToolbarGrafici =[
      {
        id:0,
        value:0,
        text:'Grafico',
        image:`assets/images/graficoTorta.svg`,
        visible:true,
        displayMode:'in-line',
      },
      {
      id:1,
      value:1,
      text:'Chiudi',
      icon:'icon-exit',
      visible:true,
      displayMode:'in-line',
      },
       
    ];

    

  }

  chiudiPopupModifica(evt:any){
    
  }

  appToolBarEvent(evt:any){
   
    switch(evt){

      case 0:{

        //this.emettiChiusuraPopup.emit(true);
      }break;

      case 1:{

        

        //this.emettiChiusuraPopup.emit(false);
      }break;

    }
   

  }

  async emettiEventoPulsante(evt){

   if(!(this.statisticheRifiutiGrafiche.dataSet as any).statistica){

     //alert('Si prega di selezionare una Statistica','Attenzione');

     //return;
   }

   let statistica = (this.statisticheRifiutiGrafiche.dataSet as any).statistica;
    
   
   
   //Costruiamo dei dati fittizzi da mandare al generatore
   if(statistica.toLowerCase() === Statistiche[0]){

     let datiCER = await this.http.get<any[]>(environment.BASE_API_URL.concat('cer')).toPromise();

     var mescola = datiCER.sort(function(){return .5 - Math.random()});

     var dati=mescola.slice(0,12);
     
     
     
     
     
     let json : IChartContent = getGraficoJSON((statistica as string),this.valore,dati);
     
     this.emettiJsonGrafico.emit(json);
     
     
    }else{
     

      
      let json : IChartContent = getGraficoJSON((statistica as string),this.valore);




      this.emettiJsonGrafico.emit(json);
    
    }


   }


      
}
